import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Eye, EyeOff, LogIn } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const LoginPage = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        try {
            await login(formData.email, formData.password);
            toast.success('Login effettuato con successo');
            navigate('/');
        } catch (error) {
            const detail = error.response?.data?.detail;
            const message = typeof detail === 'string' ? detail : 'Errore durante il login';
            toast.error(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center py-12 px-4">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <Link to="/" className="inline-block mb-4">
                        <span className="text-3xl font-bold text-primary">G-Store</span>
                    </Link>
                    <h1 className="text-2xl font-bold">Accedi al tuo account</h1>
                    <p className="text-muted mt-2">
                        Non hai un account?{' '}
                        <Link to="/register" className="text-primary hover:underline">
                            Registrati
                        </Link>
                    </p>
                </div>

                <form onSubmit={handleSubmit} className="bg-surface border border-border rounded-xl p-6 space-y-4">
                    <div>
                        <Label htmlFor="email">Email</Label>
                        <Input
                            id="email"
                            type="email"
                            value={formData.email}
                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                            placeholder="nome@email.com"
                            className="bg-surface-elevated border-border mt-1"
                            required
                            data-testid="login-email"
                        />
                    </div>

                    <div>
                        <Label htmlFor="password">Password</Label>
                        <div className="relative mt-1">
                            <Input
                                id="password"
                                type={showPassword ? 'text' : 'password'}
                                value={formData.password}
                                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                placeholder="••••••••"
                                className="bg-surface-elevated border-border pr-10"
                                required
                                data-testid="login-password"
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-muted hover:text-white"
                            >
                                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                            </button>
                        </div>
                    </div>

                    <Button
                        type="submit"
                        className="w-full btn-primary"
                        disabled={loading}
                        data-testid="login-submit"
                    >
                        {loading ? 'Accesso in corso...' : (
                            <>
                                <LogIn className="w-4 h-4 mr-2" />
                                Accedi
                            </>
                        )}
                    </Button>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;
